import {
  formatCurrency,
  // downloadThroughAnchorLink,
  formatDate,
  NoWrap,
} from "../../utils/helpers";

export const useAgentCommissionSummary = () => {
  const tableColumns = () => [
    {
      id: "as_at_date",
      header: "As At Date",
      filter: true,
    },
    {
      id: "full_name",
      header: "Full Name",
      filter: true,
    },
    {
      id: "user_number",
      header: "User Number",
      filter: true,
    },
    {
      id: "customer_type",
      header: "Customer Type",
      filter: true,
    },

    {
      id: "gl_code",
      header: "GL Code",
      filter: true,
    },
    {
      id: "debit_amount",
      header: "Debit Amount",
    },
    {
      id: "opening_balance",
      header: "Opening Balance",
    },
    {
      id: "closing_balance",
      header: "Closing Balance",
    },
    {
      id: "credit_amount",
      header: "Credit Amount",
    },
    {
      id: "net_change",
      header: "Net Change",
    },
    {
      id: "total_credits",
      header: "Total Credits",
    },
    {
      id: "total_debits",
      header: "Total Debits",
    },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,

      as_at_date: <NoWrap>{formatDate(item?.as_at_date)}</NoWrap>,
      full_name: <NoWrap>{item?.full_name}</NoWrap>,
      debit_amount: formatCurrency(item?.debit_amount || "0"),
      opening_balance: formatCurrency(item?.opening_balance || "0"),
      closing_balance: formatCurrency(item?.closing_balance || "0"),
      credit_amount: formatCurrency(item?.credit_amount || "0"),
      net_change: formatCurrency(item?.net_change || "0"),
      total_credits: formatCurrency(item?.total_credits || "0"),
      total_debits: formatCurrency(item?.total_debits || "0"),
    })) || [];

  const tableTitle = "Wallet Balance Report";

  return { tableData, tableColumns, tableTitle };
};
